import { gql } from "@apollo/client";

export const GET_STATE_BY_COUNTRY = gql`
  query GetStateByCountry {
    getStateByCountry(countryId: 48) {
      data {
        id
        name
      }
    }
  }
`;
